module.exports = __webpack_public_path__ + "static/img/empty.ab6a4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/empty.png
// module id = mN+s
// module chunks = 1